import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { gsap } from "gsap";

export default function SectionTitle({ eyebrow, title, subtitle }) {
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current) return;
        gsap.fromTo(
            ref.current,
            { opacity: 0, y: 14 },
            { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }
        );
    }, []);

    return (
        <Box ref={ref} sx={{ mb: 3 }}>
            {!!eyebrow && (
                <Typography
                    sx={{
                        color: "var(--verdeClaro)",
                        fontWeight: 900,
                        letterSpacing: "0.16em",
                        textTransform: "uppercase",
                        fontSize: 12,
                        mb: 0.75,
                    }}
                >
                    {eyebrow}
                </Typography>
            )}

            <Typography
                variant="h3"
                sx={{
                    fontWeight: 950,
                    lineHeight: 1.05,
                    letterSpacing: "-0.02em",
                }}
            >
                {title}
            </Typography>

            {!!subtitle && (
                <Typography
                    sx={{
                        mt: 1,
                        maxWidth: 880,
                        color: "rgba(255,255,255,0.78)",
                        fontSize: { xs: 14, md: 16 },
                    }}
                >
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
}